import React from 'react'
import styled from 'styled-components'

type Props = {
  type: 'text' | 'tel' | 'email'
  value: string
  onChange: React.ChangeEventHandler<HTMLInputElement>
  placeholder: string
  $errors?: string[]
}
export const TextBox: React.FC<Props> = props => {
  return (
    <StyledInput
      {...props}
      $invalid={props.$errors && props.$errors.length > 0}
    />
  )
}

const StyledInput = styled.input<{
  $invalid?: boolean
}>`
  color: #606060;
  padding: 0 12px;
  width: 100%;
  height: 42px;
  background-color: #fff;
  border: 1px solid ${props => (props.$invalid ? '#F55852' : '#ccc')};
  border-radius: 4px;
  font-size: 16px; // 16px未満にするとiOSでフォームフォーカス時にズームしてしまう
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  &::-webkit-input-placeholder {
    color: #ccc;
    padding-top: 0.2em;
  }
  &::-moz-placeholder {
    color: #ccc;
  }
  &:-ms-input-placeholder {
    color: #ccc;
  }
  &:focus {
    outline: 0;
    border: ${props => (props.$invalid ? '#F55852' : '#20AEE5')} solid 1px;
  }
`
